<template>
  <div class="vue-rqf-page">
	  
	<div v-if="$root.fleet" class="partner-logo"></div>  
	<div v-else-if="$root.partnerId" class="partner-logo"><img src="/wp-content/plugins/autotaksering/requests/assets/img/codan_orig.png" /></div>
	
    <div id="contactinfo" class="contactinfo">
      <h3>Ønsker du rutekontroll?</h3>
      
      <div class="additionals_banner"><img src="/wp-content/plugins/autotaksering/requests/assets/img/riis_frontrute.jpg" /></div>
      
      <h4>Fiks ruten mens bilen er på verksted. Jobben utføres av vår samarbeidspartner <a href="https://www.bilglass.no/" target="_blank">Riis Bilglass</a></h4>
      <label class="checkbox">
        <!--<input type="checkbox" v-model="$root.request.glass_optin">-->
        
        <!--<span>Ja, jeg har en ruteskade og ønsker denne reparert</span>-->
      </label>
      <div class="mps-actions">
	    <button id="gtm-inquiry-submit" :disabled="$root.ui.loading" @click.prevent="$root.submitAdditionals" class="button primary">Nei, det har jeg ikke</button>
        <button id="gtm-inquiry-submit" :disabled="$root.ui.loading" @click.prevent="$root.submitAdditionalsGlass" class="button secondary">Ja, jeg har en ruteskade</button>
        
      </div>
      <h6 style="
    text-align: center;
">Ved å si ja samtykker du til at dine kontaktdetaljer blir delt med Riis Bilglass, som vil ta kontakt med deg for å planlegge rutekontroll.</h6>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      //msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// Additionals.vue?c34a0a22